import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EsqueletoInteriorComponent } from './componentes/esqueleto-interior/esqueleto-interior.component';
import { PaginaPrincipalComponent } from './paginas/pagina-principal/pagina-principal.component';
import { AUTORIZACION_PAGINAS } from '../compartido/autorizacion/autorizacion.static';

const routes: Routes = [
  {
    path: '',
    component: EsqueletoInteriorComponent,
    children: [
      {
        path: '',
        component: PaginaPrincipalComponent,
        title: 'Principal',
      },
      {
        path: 'ordenes',
        loadChildren: () => import('../ordenes/ordenes.module').then((m) => m.OrdenesModule),
        title: 'Órdenes',
      },
      {
        path: 'domicilios',
        loadChildren: () =>
          import('../domicilios/domicilios.module').then((m) => m.DomiciliosModule),
        title: 'Domicilios',
      },
      {
        path: 'clientes',
        loadChildren: () => import('../clientes/clientes.module').then((m) => m.ClientesModule),
        title: 'Clientes',
      },
      {
        path: 'paquetes',
        loadChildren: () => import('../paquetes/paquetes.module').then((m) => m.PaquetesModule),
        title: 'Paquetes',
      },
      {
        path: 'planillas',
        loadChildren: () => import('../planillas/planillas.module').then((m) => m.PlanillasModule),
        title: 'Planillas',
      },
      {
        path: 'caja',
        loadChildren: () => import('../caja/caja.module').then((m) => m.CajaModule),
        title: 'Caja',
      },
      {
        path: 'facturacion',
        loadChildren: () =>
          import('../facturacion/facturacion.module').then((m) => m.FacturacionModule),
        title: 'Facturación',
      },
      {
        path: 'trayectos',
        loadChildren: () => import('../trayectos/trayectos.module').then((m) => m.TrayectosModule),
        title: 'Trayectos',
      },
      {
        path: 'campanas',
        loadChildren: () => import('../campanas/campanas.module').then((m) => m.CampanasModule),
        title: 'Campañas WhatsApp',
      },
      {
        path: 'reportes',
        loadChildren: () => import('../reportes/reportes.module').then((m) => m.ReportesModule),
        title: 'Reportes',
      },
      {
        path: 'servicios',
        loadChildren: () => import('../servicios/servicios.module').then((m) => m.ServiciosModule),
        title: 'Servicios',
      },
      {
        path: 'rastreo',
        loadChildren: () => import('../rastreo/rastreo.module').then((m) => m.RastreoModule),
        title: 'Rastreo',
      },
      {
        path: 'crm',
        loadChildren: () => import('../crm/crm.module').then((m) => m.CrmModule),
        title: 'CRM',
      },
      {
        path: 'calendario',
        loadComponent: () =>
          import('../compartido/calendario/calendario.component').then(
            (m) => m.CalendarioComponent,
          ),
        title: 'Calendario',
      },
      {
        path: 'tareas-eleva',
        loadChildren: () =>
          import('./paginas/tareas-eleva/tareas-eleva.module').then((m) => m.TareasElevaModule),
        title: 'Tareas de Eleva',
        data: { autorizacion: AUTORIZACION_PAGINAS['Tareas de Eleva'] },
      },
      {
        path: 'tareas-org',
        loadChildren: () =>
          import('./paginas/tareas-org/tareas-org.module').then((m) => m.TareasOrgModule),
        title: 'Tareas de Organización',
        data: { autorizacion: AUTORIZACION_PAGINAS['Tareas de Organización'] },
      },
      {
        path: 'tareas-aliado',
        loadChildren: () =>
          import('./paginas/tareas-aliado/tareas-aliado.module').then((m) => m.TareasAliadoModule),
        title: 'Tareas de Aliado',
        data: { autorizacion: AUTORIZACION_PAGINAS['Tareas de Aliado'] },
      },
      {
        // CASO ESPECIAL: Evedisa Eje Cafetero (Calle 22)
        path: 'evedisa-22',
        loadComponent: () =>
          import('./paginas/evedisa-22/evedisa-22.component').then((m) => m.Evedisa22Component),
        title: 'Evedisa 22',
      },
      {
        // CASO ESPECIAL: Evedisa Eje Cafetero (Aliados)
        path: 'moleculas-evedisa',
        loadComponent: () =>
          import('./paginas/moleculas-evedisa/moleculas-evedisa.component').then(
            (m) => m.MoleculasEvedisaComponent,
          ),
        title: 'Moléculas Evedisa',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InteriorRoutingModule {}
